import React, { useState } from 'react';
import { Box, Typography, Grid, TextField } from '@mui/material';
import { FormComponentProps, SpouseInfoData } from '../../types/forms';

const SpouseInfo: React.FC<FormComponentProps<SpouseInfoData>> = ({ data, onNext }) => {
  const [spouseData, setSpouseData] = useState<SpouseInfoData>(() => {
    if (data) {
      return data;
    }
    return {
      firstName: '',
      middleName: '',
      lastName: '',
      dateOfBirth: '',
      ssn: '',
      email: '',
      mobile: '',
      workPhone: ''
    };
  });

  const handleChange = (field: keyof SpouseInfoData, value: string) => {
    const updatedData = { ...spouseData, [field]: value };
    setSpouseData(updatedData);
    onNext(updatedData);
  };

  return (
    <Box>
      <Typography variant="h3" gutterBottom sx={{ fontWeight: 400 }}>
        Spouse Information
      </Typography>
      <Typography variant="h6" color="text.secondary" paragraph sx={{ fontWeight: 400 }}>
        Please provide your spouse's information for tax filing purposes.
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label="First Name"
            value={spouseData.firstName}
            onChange={(e) => handleChange('firstName', e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label="Middle Name"
            value={spouseData.middleName}
            onChange={(e) => handleChange('middleName', e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label="Last Name"
            value={spouseData.lastName}
            onChange={(e) => handleChange('lastName', e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Date of Birth"
            type="date"
            value={spouseData.dateOfBirth}
            onChange={(e) => handleChange('dateOfBirth', e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="SSN"
            value={spouseData.ssn}
            onChange={(e) => handleChange('ssn', e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label="Email"
            type="email"
            value={spouseData.email}
            onChange={(e) => handleChange('email', e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label="Mobile Phone"
            value={spouseData.mobile}
            onChange={(e) => handleChange('mobile', e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label="Work Phone"
            value={spouseData.workPhone}
            onChange={(e) => handleChange('workPhone', e.target.value)}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default SpouseInfo; 